module.exports = __webpack_public_path__ + "img/loading.946f497c.gif";